export const systemInfoManagement = {
    all: '全て',
    title: 'システム情報管理',
    new: '新規登録',
    edit: '編集',
    tableColumnId: 'ID',
    tableColumnTitle: 'タイトル',
    tableColumnStatus: 'ステータス',
    tableColumnCreater: '最終更新者',
    tableColumnCreateDate: '最終更新日',
    tableColumnEffectiveDate: '有効期',
    updater: '最終更新者',
    updateDate: '最終更新日',
    cancelText: '取消',
    delText: '削除',
    saveText: '保存',
    openText: '公開',
    closeText: '非公開',
    modaleffectiveDate: '有効期限',
    modaltitle: 'タイトル',
    modalcontext: '本文',
    required: 'を入力してください。',
    plan: '契約プラン',
    status: 'ステータス',
    no: 'なし',
    tableColumnPlan: '契約プラン',
    successMsg: '処理が正常終了しました。',
    errorMsg: '処理が失敗しました。'
}
